import React from 'react';
import styled from '@emotion/styled';
import Divider from '@mui/material/Divider';
import Button from "@imminently/decisively-ui/Button";

export const ActionDivider = styled(Divider)`
  margin: 0 -1rem 0 -1rem;
`;

export const ActionButton = styled(Button)`
  padding: 0.25rem;
`;

/** @type { React.FC< { actions: any[] } > } */
export const ActionsComp = React.memo(({ actions }) => {
  if (!actions) return null;

  const freeSpaceClick = e => {
    e.preventDefault();
  };

  return (
    <>
      <ActionDivider />
      <div
        className="grid grid-flow-col auto-cols-max justify-between gap-2 py-2"
        onClick={freeSpaceClick}
      >
        {actions.map(a => (
          <div key={a.name}>
            <ActionButton variant="ghost" size="sm" startIcon={a.icon} onClick={a.onClick} disabled={a.disabled}>
              {a.name}
            </ActionButton>
          </div>
        ))}
      </div>
    </>
  );
});

ActionsComp.displayName = 'Menu/ActionsComp';